import { forwardRef } from "react";

import { TypographyWrapper } from "./MuiTypography.style";
import { TypographyProps } from "@mui/material";

type MuiTypographyProps = TypographyProps & {
  component?: string;
  htmlFor?: string;
};

export const MuiTypography = forwardRef<HTMLSpanElement, MuiTypographyProps>(
  function MuiTypography(props, ref) {
    return <TypographyWrapper {...props} ref={ref} />;
  },
);
